import { Box } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { CommentScheduleAvatar } from "./comment-schedule-avatar"

const MAX_AVATARS = 3
const SIZE = 30

// The overlapping commenter avatars shown on the right of a schedule card. Shows up to `MAX_AVATARS`
// distinct commenters (newest activity first) and a "+N" overflow circle for the rest, mirroring the
// stacked-avatar treatment in the design. Overlap is pure CSS (negative left margin on every circle
// after the first) so it works with `<Repeat>` rendering its items as direct flex children.
export function CommentScheduleAvatarStack({ commenters = [] }) {
    const shown = commenters.slice(0, MAX_AVATARS)
    const overflow = commenters.length - shown.length

    return (
        <Box
            data-cy="comment-schedule-avatars"
            sx={{ display: "flex", alignItems: "center", "& > *:not(:first-of-type)": { ml: "-8px" } }}
        >
            <Repeat list={shown} pass="commenter" keyFn={commenterKey} item={<CommentScheduleAvatar />} />
            <If truthy={overflow > 0}>
                <Box
                    data-cy="comment-schedule-avatar-overflow"
                    sx={{
                        width: SIZE,
                        height: SIZE,
                        borderRadius: "50%",
                        border: "2px solid",
                        borderColor: "background.paper",
                        bgcolor: "background.neutral",
                        color: "text.secondary",
                        fontSize: 11,
                        fontWeight: 700,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    +{overflow}
                </Box>
            </If>
        </Box>
    )

    function commenterKey(commenter, index) {
        return commenter?.userId ?? commenter?.displayName ?? index
    }
}
